import { useMutation } from 'react-query';
import bindTenantToRoom from '../requests/bindTenantToRoom';

const useBindTenantToRoomMutation = (options) =>
  useMutation(({ values }) => bindTenantToRoom(values), options);

export default useBindTenantToRoomMutation;
